import styled from "styled-components/macro";

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  width: 100%;
  padding: 0 2rem;
`;

export const Label = styled.label`
  text-transform: uppercase;
  font-size: 1rem;
`;

export const FormGroup = styled.div`
  padding-bottom: 1rem;
  margin: 0;
`;

export const InputGroup = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 0;
  width: 100%;
`;

export const Input = styled.input`
  -webkit-transition: all 0.3s ease-in-out;
  -moz-transition: all 0.3s ease-in-out;
  -ms-transition: all 0.3s ease-in-out;
  -o-transition: all 0.3s ease-in-out;
  outline: none;
  background-color: #fff;
  border: 1px solid rgba(29, 29, 29);
  color: rgba(29, 29, 29);
  width: 270px;
  height: 40px
  padding-left: 0.5rem;

  box-shadow: 0;
  :focus {
    box-shadow: 0 0 5px rgba(118, 13, 23, 1);
    border: 2px solid rgba(118, 13, 23, 0.5);
    background-color: rgba(115, 115, 115);
    background-color: #fff;
    color: rgba(29, 29, 29);
  }
`;

export const MenuWrapper = styled.div`
  display: flex;
  flex: 0 0 auto;
  justify-content: center;
  align-items: center;
`;
